export class ModuleTableName{
    constructor(public moduleName: string, public tableName: string, fresh: number = 0){
        fresh ? this.fresh = fresh : this.fresh = 0;
    }
    public readonly fresh: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/module-table-name.ts